export const CONTENT_EVENTS = {
  collectionOpened: 'content_collection_opened',
  collectionPressed: 'content_collection_pressed',
  featuredCollectionPressed: 'content_featured_collection_pressed',
  challengeOpened: 'content_challenge_opened',
  episodePressed: 'content_episode_pressed',
  searchOpened: 'content_search_opened',
  searchExecuted: 'content_search_executed',
  searchResultPressed: 'content_search_result_pressed',
  itemShared: 'content_item_shared',
  shareCancelled: 'content_share_cancelled',
} as const;

export type ContentEventNameType = (typeof CONTENT_EVENTS)[keyof typeof CONTENT_EVENTS];
